module.exports = __webpack_public_path__ + "img/results_loader.26ef8bb4.gif";